import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import blogPosts from '../data/blogPosts.json';
import { formatDistance } from 'date-fns';
import { BlogPost } from '../types/blog';

const BlogList: React.FC = () => {
  const posts = blogPosts as BlogPost[];
  
  // Sort posts by publish date in descending order (newest first)
  const sortedPosts = posts.sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime());

  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>Blog | SpreadsheetChallenges</title>
        <meta name="description" content="Read our latest articles on Excel, Google Sheets, and spreadsheet techniques." />
        <meta property="og:title" content="Blog | SpreadsheetChallenges" />
        <meta property="og:description" content="Read our latest articles on Excel, Google Sheets, and spreadsheet techniques." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://spreadsheetchallenges.com/blog" />
      </Helmet>
      
      <div className="max-w-5xl mx-auto">
        <h1 className="text-4xl font-bold mb-2">Blog</h1>
        <p className="text-lg text-muted-foreground mb-8">
          The latest articles and tutorials on spreadsheet skills and techniques
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {sortedPosts.map((post) => (
            <Card key={post.id} className="flex flex-col h-full">
              <div className="aspect-video relative overflow-hidden">
                <img 
                  src={post.image} 
                  alt={post.title}
                  className="object-cover w-full h-full transition-transform hover:scale-105 duration-300"
                />
              </div>
              <CardHeader>
                <CardTitle className="line-clamp-2">{post.title}</CardTitle>
                <CardDescription>
                  {formatDistance(new Date(post.publishDate), new Date(), { addSuffix: true })} • {post.author}
                </CardDescription>
              </CardHeader>
              <CardContent className="flex-grow">
                <p className="text-muted-foreground line-clamp-3">{post.summary}</p>
              </CardContent>
              <CardFooter>
                <Button asChild className="w-full">
                  <Link to={`/blog/${post.slug}`}>Read More</Link>
                </Button>
              </CardFooter>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogList; 